"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 79: NINA-03 / NINA-06
 * ------------------------------------------------------------------ *
 * GxROM-style banking (32 KB PRG + 8 KB CHR) with the register out in
 * the expansion area instead of the cartridge space. The address decode
 * is (address & $E100) == $4100, which lights up $4100, $4300, ...
 * $5F00 -- every $xx00 whose low half sits in the expansion range.
 * Register format .... PCCC: bit 3 = 32 KB PRG bank, bits 0-2 = 8 KB
 * CHR bank.
 * Used by Tiles of Fate, Krazy Kreatures, Impossible Mission II...
 * See https://www.nesdev.org/wiki/INES_Mapper_079
 */

function register(Mappers) {
  Mappers[79] = function (nes) {
    this.nes = nes;
  };

  Mappers[79].prototype = new Mappers[0]();

  Mappers[79].prototype.write = function (address, value) {
    if ((address & 0xe100) === 0x4100) {
      // ...P CCC -- one bit of 32 KB PRG, three of 8 KB CHR.
      this.load32kRomBank((value >> 3) & 0x01, 0x8000);
      this.load8kVromBank((value & 0x07) * 2, 0x0000);
      return;
    }

    // Everything else only exists below $8000: a write to PRG space is a
    // no-op on hardware, and NROM's handler would scribble on cpu.mem.
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
    }
  };
}

module.exports = { register: register };
